import InnerBanner from "../Components/InnerBanner/InnerBanner";
import MultiContent from "../Components/MultiContent/MultiContent";

function Remote() {
    return (
        <>
            <InnerBanner
                img_url='remoteBanner.webp'
                heading={['DevOps Virtual Online Courses That', <br/>, 'Can Be Accessed Anywhere']}
            />
            <MultiContent
                left_img
                bottomHeading
                heading="Why Choose Skill Bridge's Virtual Online Courses?"
                descClass='med'
                description={[
                    "Skill Bridge is thrilled to bring DevOps education to your doorstep with our virtual online courses. We understand that modern learning demands flexibility and accessibility, and our remote courses deliver just that. Dive into the world of DevOps from the comfort of your home or office while benefiting from the same high-quality education and expert guidance as our onsite programs"
                ]}
                img_url='remote1.webp'
                accordion={[
                    {
                        'head': 'Access Anywhere',
                        'content': "Our virtual courses break down geographical barriers. Whether you're across town or across\n" +
                            "the globe, DevOps knowledge is just a click away."
                    },
                    {
                        'head': 'Flexible Learning',
                        'content': "Life's busy, but learning should adapt to your schedule. Our virtual courses let you choose\n" +
                            "when and where you study, ensuring a customised learning experience.\n"
                    },
                    {
                        'head': 'Expert-Led',
                        'content': 'Seasoned DevOps professionals lead our courses, sharing their real-world expertise with\n' +
                            "you. You'll gain insights and guidance from the best in the field."
                    },
                    {
                        'head': 'Interactive Engagement',
                        'content': 'Engagement fuels effective learning. Our virtual courses are interactive, featuring live\n' +
                            'sessions, discussions, and hands-on activities to keep you actively involved.'
                    },
                    {
                        'head': 'Immediate Application',
                        'content': "DevOps is practical, and so are our courses. You'll acquire hands-on skills that can be\n" +
                            "applied right away in your career.\n"}
                ]}
            />
            <MultiContent
                right_img
                class="coloured"
                topHeading
                heading="Upcoming Dates and Easy Registration"
                description={[
                    "Enrolling in our on-site courses is straightforward. Explore our course calendar to discover upcoming dates that align with your schedule, then follow these steps:"
                ]}
                img_url='remote2.webp'
                accordion={[
                    {
                        'head': 'Select Your Course',
                        'content': 'Explore our course offerings and pick the one aligning with your career aspirations.\n'
                    },
                    {
                        'head': 'Sign Up\n',
                        'content': 'Hit the "Sign Up" button on the course page and follow a straightforward registration\n' +
                            'process'
                    },
                    {
                        'head': 'Make Payments',
                        'content': "Our secure payment options ensure a hassle-free registration. After payment confirmation,\n" +
                            "you'll receive course access details.\n"
                    },
                    {
                        'head': 'Commence Learning',
                        'content': 'On your course start date, you\'ll enter our virtual classroom and embark on your DevOps\n' +
                            'journey.'
                    },
                ]}
            />
            <MultiContent
                right_img
                tag="how we work"
                topHeading
                heading="The Gateway to DevOps Excellence Awaits"
                description={[
                    "Location should never limit your ambitions. With Skill Bridge's virtual online courses, you can launch your DevOps journey from anywhere in the world. Join our global community of learners and equip yourself with the knowledge and skills that will reshape your career.",
                    "Seize this opportunity to control your professional future. Browse our upcoming virtual courses, sign up today, and embrace DevOps on your own terms. Your path to success is just a click away.",
                ]}
                img_url='remote3.webp'
            />
        </>
    )
}

export default Remote